import React from 'react';
import { StyledAnchor, StyledGrid } from './styles';
import { FaFacebook, FaInstagram } from "react-icons/fa";
import useWindowDimensions from '../../Hooks/useWindowDimensions';
import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import markerIconPng from "leaflet/dist/images/marker-icon.png"
import {Icon} from 'leaflet'
import { Grid } from '@mui/material';

const containerStyleDesktop :React.CSSProperties = {
  width: '50%',
  height: '100%',
};
const containerStyleMobile :React.CSSProperties = {
  width: '90vw',
  height: '200px'
};

const responsiveFlexMapDesktop: React.CSSProperties = {
  display:'flex',
  justifyContent:'start'
}

const responsiveFlexMapMobile: React.CSSProperties = {
  display:'flex',
  justifyContent:'center'
}
const Footer: React.FC = () => {
  const {width} = useWindowDimensions();
  return (
    <StyledGrid container>
      <Grid style={{textAlign:'center'}} item xs={12} >
        <h3>Redes Sociais</h3>
        <StyledAnchor
          href="https://www.instagram.com/planetarioufsm/">
            <FaInstagram/>
        </StyledAnchor>
        <StyledAnchor
          href="https://www.facebook.com/planetarioufsm1/">
            <FaFacebook/>
        </StyledAnchor>
      </Grid>
      <Grid style={{textAlign:'right',paddingRight:'1em'}} item md={6} xs={12}>
        <h3>Localização</h3>
        <p>Praça Santos Dumont, Prédio 45</p>
        <p>Cidade Universitária</p>
        <p>Bairro Camobi</p>
        <p>Santa Maria - RS</p>
        <p>CEP: 97105-900</p>
        <p>+55 (55) 3220-8226</p>
        <p>planetario@ufsm.br</p>
      </Grid>
      <Grid style={width< 960 ? responsiveFlexMapMobile : responsiveFlexMapDesktop}  item md={6} xs={12} >
        <MapContainer 
          style={width< 960 ? containerStyleMobile : containerStyleDesktop} 
          center={[-29.72005,-53.71731]} 
          zoom={20} 
          scrollWheelZoom={false}>
          <TileLayer
            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <Marker icon={new Icon({iconUrl: markerIconPng, iconSize: [25, 41], iconAnchor: [12, 41]})} position={[-29.72005,-53.71731]}>
            <Popup>
              Planetário UFSM
            </Popup>
          </Marker>
        </MapContainer>
      </Grid>
      <Grid item xs={12} style={{ textAlign: 'center' }}>
        <small style={{fontSize:'13px'}} >Desenvolvido por @phvrossato</small>
      </Grid>
    </StyledGrid>
  );
};

export default Footer;
